exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_container__3HfBN {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.styles_pagePadding__TWPHT {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* padding: 10px; */\n  height: 100%;\n}\n\n.styles_fullWidthButton__2Yo40 {\n  flex: 1 0 auto;\n  border-radius: 0 !important;\n  z-index: 222;\n}\n\n/* .fullWidthButton span {\n  font-size: 0.8rem !important;\n} */", ""]);

// Exports
exports.locals = {
	"container": "styles_container__3HfBN",
	"pagePadding": "styles_pagePadding__TWPHT",
	"fullWidthButton": "styles_fullWidthButton__2Yo40"
};